import { Entity, Id, runIfDefined } from '../../../common'
import { ROTransaction, RWTransaction } from '../../../db'

export enum DocumentType {
  PASSPORT = 'PASSPORT',
  OTHER = 'OTHER',
}

export function documentTypeName(name?: DocumentType): string | undefined {
  if (name) {
    switch (name) {
      case DocumentType.PASSPORT:
        return 'Паспорт'

      case DocumentType.OTHER:
        return 'Иное'
    }
  } else {
    return
  }
}

export interface CitizenDocument extends Entity {
  type: DocumentType
  series?: string
  num?: string
  issue?: string
  date?: Date
  name?: string
  info?: string
  citizenId: Id
}

export interface CitizenDocumentsRepository {
  findAllByCitizenIds(tx: ROTransaction, citizenIds: Id[]): Promise<CitizenDocument[]>
  findByPassportData(tx: ROTransaction, series: string, num: string): Promise<CitizenDocument | undefined>
  save(tx: RWTransaction, citizenDocuments: CitizenDocument[]): Promise<void>
  delete(tx: RWTransaction, id: Id, deletedAt: Date): Promise<void>
}

export interface AddCitizenDocument {
  type: DocumentType
  series?: string
  num?: string
  issue?: string
  date?: Date
  name?: string
  info?: string
}

export interface CitizenDocumentInfo {
  type: string
  info: string
  name: string
}

export function getCitizenDocumentInfo(documents: CitizenDocument[]): CitizenDocumentInfo {
  const passportDoc = documents.find(doc => doc.type === DocumentType.PASSPORT)
  if (passportDoc) {
    return {
      type: documentTypeName(passportDoc.type) || '-',
      info: [passportDoc.series, passportDoc.num].filter(val => val).join(' '),
      name: documentTypeName(passportDoc.type) || '-',
    }
  }
  const otherDoc = documents.length > 0 ? documents[0] : undefined
  return {
    type: runIfDefined(otherDoc, d => documentTypeName(d.type)) ?? '-',
    info: otherDoc?.info || '-',
    name: otherDoc?.name || '-',
  }
}
